// test1392
(1392 && 0);
